import { useCallback } from "react";
import type { UseInstantTransformEvent } from "@b2bportal/core-tracking";
import type {
  ViewedInsuranceRawEvent,
  ViewedInsuranceEvent,
  ViewedInsuranceTermsRawEvent,
  ViewedInsuranceTermsEvent,
  SelectedInsuranceRawEvent,
  SelectedInsuranceEvent,
} from "./events/insurance";
import { InsuranceEventName } from "./events/insurance";
import type {
  SelectTermsRawEvent,
  SelectTermsEvent,
  ViewedTermsRawEvent,
  ViewedTermsEvent,
} from "./events/payment";
import { PaymentEventName } from "./events/payment";

/**
 * Transformer for viewed_insurance event
 */
export const useViewedInsuranceTransformer: UseInstantTransformEvent<
  ViewedInsuranceRawEvent,
  ViewedInsuranceEvent
> = () => {
  return useCallback(
    (event) => ({
      name: InsuranceEventName.viewed_insurance,
      properties: {
        policies_available: event.properties.policies_available.length,
      },
    }),
    []
  );
};

/**
 * Transformer for viewed_insurance_terms event
 */
export const useViewedInsuranceTermsTransformer: UseInstantTransformEvent<
  ViewedInsuranceTermsRawEvent,
  ViewedInsuranceTermsEvent
> = () => {
  return useCallback(
    (event) => ({
      name: InsuranceEventName.viewed_insurance_terms,
      properties: {
        insurance_policy: event.properties.insurance_policy,
      },
    }),
    []
  );
};

/**
 * Transformer for selected_insurance event
 */
export const useSelectedInsuranceTransformer: UseInstantTransformEvent<
  SelectedInsuranceRawEvent,
  SelectedInsuranceEvent
> = () => {
  return useCallback(
    (event) => ({
      name: InsuranceEventName.selected_insurance,
      properties: {
        insurance_policy: event.properties.insurance_policy,
        insurance_policy_total: event.properties.insurance_policy_total,
      },
    }),
    []
  );
};

/**
 * Transformer for select_terms event
 */
export const useSelectTermsTransformer: UseInstantTransformEvent<
  SelectTermsRawEvent,
  SelectTermsEvent
> = () => {
  return useCallback(
    () => ({
      name: PaymentEventName.select_terms,
      properties: {},
    }),
    []
  );
};

/**
 * Transformer for viewed_terms event
 */
export const useViewedTermsTransformer: UseInstantTransformEvent<
  ViewedTermsRawEvent,
  ViewedTermsEvent
> = () => {
  return useCallback(
    (event) => ({
      name: PaymentEventName.viewed_terms,
      properties: {
        link: event.properties.link,
      },
    }),
    []
  );
};
